var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReferences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.25,
    width: 48,
    height: 48,
    rx: 3,
    fill: "#FFF9EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 23.0225H15.143V33.6738H10.9999V23.0225Z",
    fill: "#330C00",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1432 31.7916C15.1432 31.7916 17.9702 33.9954 21.3906 34.1672C24.8111 34.339 31.7355 29.2562 31.7355 29.2562C32.9961 28.3478 31.7137 25.4431 29.1448 26.541L25.5199 28.4406L22.7048 28.2511",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8893 20.5131C27.7846 20.2406 28.7434 20.3749 28.7434 20.3749C30.3534 20.4539 31.8919 21.1588 32.9917 22.3792L37.2381 28.5381C38.5702 30.1199 37.9805 31.6996 36.8093 32.1913C36.8093 32.1913 35.9298 32.5546 35.2966 32.1301",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1432 24.3768C15.1432 24.3768 18.9349 22.9017 21.7837 21.9775",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3938 15.9907C19.2821 16.7944 19.0458 18.3307 19.8637 19.4207L20.6836 20.5127L24.7076 17.6041L23.8877 16.5121C23.0698 15.422 21.5055 15.189 20.3938 15.9927V15.9907Z",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7492 31.2633L30.9786 34.2332L35.0026 31.3245L31.6853 26.9032L24.7074 17.6025L20.6834 20.5132L26.3173 28.0228",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9794 34.2334L31.1104 34.4091L36.7226 37.7503L35.1344 31.5005L35.0034 31.3247L30.9794 34.2334Z",
    fill: "#330C00",
    stroke: "#330C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7037 10.7498C30.7037 12.5409 32.1867 13.9947 34.0151 13.9947C32.1867 13.9947 30.7037 15.4464 30.7037 17.2396C30.7037 15.4484 29.2207 13.9947 27.3923 13.9947C29.2207 13.9947 30.7037 12.5429 30.7037 10.7498Z",
    stroke: "#2DC48A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9285 13.6089C12.9285 14.6609 13.7922 15.5148 14.8571 15.5148C13.7922 15.5148 12.9285 16.3674 12.9285 17.4206C12.9285 16.3686 12.0648 15.5148 11 15.5148C12.0648 15.5148 12.9285 14.6621 12.9285 13.6089Z",
    stroke: "#2DC48A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0709 17.4204C36.0709 18.4724 36.9346 19.3263 37.9995 19.3263C36.9346 19.3263 36.0709 20.179 36.0709 21.2322C36.0709 20.1801 35.2072 19.3263 34.1423 19.3263C35.2072 19.3263 36.0709 18.4736 36.0709 17.4204Z",
    stroke: "#2DC48A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferences);
export default __webpack_public_path__ + "static/media/icon-references.2102f26981928528dc84cba786db45a2.svg";
export { ForwardRef as ReactComponent };